import { absolutePath } from "./absolutePath";

export interface StorageUsageParams {
  page?: number;
  per_page?: number;
}

interface StorageUsageFnProps {
  params?: StorageUsageParams;
}

export const storageUsage = {
  list: ({ params }: StorageUsageFnProps = {}) =>
    absolutePath("storage/usage", params),
};
